<template>
  <div>
    <pxkeji-rightHeader />

    <div class="pxkeji-right-box">
      <a-form class="ant-advanced-search-form">
        <a-row :gutter="24">
          <a-col :span="8">
            <a-form-item label="用户">
              <a-input placeholder="姓名/手机号/用户名" v-model="where.keyword.name" />
            </a-form-item>
          </a-col>

          <a-col :span="4">
            <a-form-item label="状态">
              <a-select v-model="where.keyword.status" placeholder="请选择" allowClear>
                <a-select-option value>全部</a-select-option>
                <a-select-option value="0">禁用</a-select-option>
                <a-select-option value="1">启用</a-select-option>
              </a-select>
            </a-form-item>
          </a-col>
        </a-row>
        <a-row>
          <a-col :span="24" :style="{ textAlign: 'right' }">
            <a-button type="primary" @click="searchList" v-btnlimit="'用户列表-搜索'">搜索</a-button>
          </a-col>
        </a-row>
      </a-form>
    </div>

    <div class="pxkeji-right-box">
      <pxkeji-btn name="添加" class="pxkeji_basic_btn" @click="showInfo({'id':0})" type="primary" v-btnlimit="'用户列表-添加'"/>
      <!-- <pxkeji-btn name="批量导出" v-if="selectRows.length>0" class="pxkeji_basic_btn"/> -->
      <pxkeji-btn
        name="批量启用"
        v-if="selectRows.length>0"
        v-btnlimit="'用户列表-批量启用'"
        @click="batchEnable()"
        class="pxkeji_basic_btn"
      />
      <pxkeji-btn
        name="批量禁用"
        v-if="selectRows.length>0"
        v-btnlimit="'用户列表-批量禁用'"
        @click="batchDisEnable()"
        class="pxkeji_basic_btn"
      />

      <a-table
        :columns="list.columns"
        rowKey="id"
        :pagination="list.pagination"
        @change="onChange"
        :dataSource="list.datas"
        :loading="isloading"
        :rowSelection="{type:'checkbox',onChange:onRowChange,selectedRowKeys:selectRows}"
        :locale="{emptyText:'暂无数据'}"
      >
        <span slot="roles" slot-scope="roles">
          <a-tag v-for="info in roles" :key="info.id" color="green">{{info.name}}</a-tag>
        </span>
        <span slot="status" slot-scope="status">
          <a-tag v-if="status" color="green">启用</a-tag>
          <a-tag v-else color="red">禁用</a-tag>
        </span>
        <span slot="action" slot-scope="info">
          <pxkeji-btn name="编辑" @click="showInfo(info)" size="small" type="primary" v-btnlimit="'用户列表-编辑'"/>
          <a-divider type="vertical" />


          <a-dropdown>
            <a-menu slot="overlay">

              <a-menu-item key="1">

                <pxkeji-btn
                    name="禁用"
                    v-btnlimit="'用户列表-启用禁用'"
                    @click="handleProhibit(info.id,0)"
                    size="small"
                    type="dashed"
                    v-if="info.status==1"
                />
                <pxkeji-btn
                    name="启用"
                    v-btnlimit="'用户列表-启用禁用'"
                    @click="handleProhibit(info.id,1)"
                    size="small"
                    type="dashed"
                    v-else
                />
              </a-menu-item>

               <a-menu-item key="2">
                <pxkeji-btn
                    name="解锁"
                    v-btnlimit="'用户列表-解锁'"
                    :roles="[]"
                    @click="unlocking(info.id)"
                    size="small"
                    type="dashed"
                />
              </a-menu-item>
            </a-menu>
            <a-button size="small" type="dashed">
              更多
              <a-icon type="down"/>
            </a-button>
          </a-dropdown>
        </span>
      </a-table>
      <div class="totalbox" style="float: left;">
        <div>
          <span>用户总人数：{{list.pagination.total}}个</span>
        </div>
      </div>
    </div>

    <a-modal
      :title="addedit.title"
      v-model="addedit.visible"
      width="60%"
      :footer="false"
      destroyOnClose
      :maskClosable="false"
    >
      <userInfo :infos="addedit.info" @callbackMethod="save" />
    </a-modal>
  </div>
</template>
<script>
var that;
import userInfo from "./userInfo.vue";

const columns = [
  {
    dataIndex: "id",
    key: "id",
    align: "center",
    title: "用户编号"
  },
  {
    dataIndex: "name",
    key: "name",
    align: "center",
    title: "用户名"
  },
  {
    dataIndex: "realName",
    key: "realName",
    align: "center",
    title: "真实姓名"
  },
  {
    dataIndex: "telephone",
    key: "telephone",
    align: "center",
    title: "手机号码"
  },
  {
    dataIndex: "addTime",
    key: "addTime",
    align: "center",
    title: "创建日期"
  },
  {
    dataIndex: "roles",
    key: "roles",
    align: "center",
    title: "角色",
    scopedSlots: { customRender: "roles" }
  },
  {
    dataIndex: "status",
    key: "status",
    align: "center",
    title: "状态",
    scopedSlots: { customRender: "status" }
  },
  {
    title: "操作",
    key: "action",
    align: "center",
    scopedSlots: { customRender: "action" }
  }
];

export default {
  name: "userlist",
  data() {
    return {
      rolelist: [],
      role: "",
      expand: false, //高级搜索
      list: {
        columns, //表头
        datas: [], //数据
        pagination: {
          //分页器
          showQuickJumper: true,
          hideOnSinglePage: true,
          total: 0,
          current: 1, //页码
          defaultPageSize: 10 //页容
        }
      },
      where: {
        //查询条件
        keyword: {
          //搜索条件
          name: "",
          status: ""
        }
      },
      addedit: {
        title: "",
        info: {},
        id: 0,
        visible: false
      },
      selectRows: [], //选中项编号
      infoId: 0, //添加时为0，修改是为编号
      isloading: false,
      visible: false //弹框
    };
  },
  components: {
    userInfo: userInfo
  },
  mounted: function() {
    this.$nextTick(function() {
      that = this;
      this.GetList();
    });
  },
  watch: {
    selectRows: function() {}
  },
  methods: {

    //解锁
    unlocking(id) {
      that = this;
      that.isloading = true;
      that.$api.user
          .unlockingUser(id)
          .then(res => {
            that.isloading = false;
            if (res.errorCode == that.$msg.responseCode.success) {
              that.$message.success(res.errorMsg);
              that.GetList();
            } else {
              that.$message.error(res.errorMsg);
            }
          })
          .catch(() => {
            that.isloading = false;
          });
    },

    toggle() {
      this.expand = !this.expand;
    },
    GetList() {
      //获取用户列表
      this.isloading = true;
      this.clearRows();
      this.$api.user
        .pageListAdmin(
          this.list.pagination.current,
          this.list.pagination.defaultPageSize,
          this.where.keyword.name,
          this.where.keyword.status
        )
        .then(res => {
          this.isloading = false;
          if (res.errorCode == this.$msg.responseCode.success) {
            this.list.datas = res.data.records;
            this.list.pagination.total = Number(res.data.total);
          } else {
            this.$message.error(res.errorMsg);
          }
        })
        .catch(() => {
          this.isloading = false;
        });
    },

    onChange(page) {
      //页面切换回调
      this.list.pagination.current = page.current;
      this.GetList();
    },
    onRowChange(selectedRowKeys) {
      //table 多选
      this.selectRows = selectedRowKeys;
    },
    clearRows() {
      //清空选中项
      this.selectRows = [];
    },
    searchList() {
      this.list.pagination.current = 1;
      this.GetList();
    },
    clear() {
      //清空搜索条件
      for (var info in this.where.keyword) {
        this.where.keyword[info] = "";
      }
    },
    showInfo(info) {
      //打开弹出框
      this.addedit.visible = true;
      this.addedit.title = info.id ? "编辑" : "新增";
      this.addedit.info = info;
    },
    save(f) {
      this.addedit.visible = false;
      if (f) {
        this.GetList();
      }
    },
    /* 删除 */
    delInfo(id) {
      this.$confirm({
        title: "您确定要删除此项吗?",
        okText: "确定",
        okType: "danger",
        cancelText: "我再想想",
        onOk() {
          that.isloading = true;
          that.$api.security.user
            .deleteUser(id)
            .then(res => {
              that.isloading = false;
              if (res.errorCode == that.$msg.responseCode.success) {
                that.$message.success(res.errorMsg);
                that.GetList();
              } else {
                that.$message.error(res.errorMsg);
              }
            })
            .catch(() => {
              that.isloading = false;
            });
        },
        onCancel() {}
      });
    },
    /*批量启用 */
    batchEnable() {
      this.handleProhibit(this.selectRows.join(","), 1);
    },
    /*批量禁用 */
    batchDisEnable() {
      this.$confirm({
        title: "您确定要执行批量禁用的操作吗?",
        okText: "确定",
        okType: "danger",
        cancelText: "我再想想",
        onOk() {
          that.handleProhibit(that.selectRows.join(","), 0);
        },
        onCancel() {}
      });
    },
    /*禁用启用 */
    handleProhibit(ids, status) {
      that.isloading = true;
      that.$api.user
        .prohibit(ids, status)
        .then(res => {
          that.isloading = false;
          if (res.errorCode == that.$msg.responseCode.success) {
            that.$message.success(res.errorMsg);
            that.GetList();
          } else {
            that.$message.error(res.errorMsg);
          }
        })
        .catch(() => {
          that.isloading = false;
        });
    },
    /*启用禁用*/
    bthEnable(ids, status) {
      that.isloading = true;
      that.$api.security.user
        .updateStatus(ids, status == 1 ? 0 : 1)
        .then(res => {
          that.isloading = false;
          if (res.errorCode == that.$msg.responseCode.success) {
            that.$message.success(res.errorMsg);
            that.GetList();
          } else {
            that.$message.error(res.errorMsg);
          }
        })
        .catch(() => {
          that.isloading = false;
        });
    },
    resetpaw(id) {
      this.$confirm({
        title: "您确定要执行重置密码的操作吗?",
        okText: "确定",
        okType: "danger",
        cancelText: "我再想想",
        onOk() {
          that.isloading = true;
          that.$api.security.user
            .resetPassword(id)
            .then(res => {
              that.isloading = false;
              if (res.errorCode == that.$msg.responseCode.success) {
                that.$message.success(res.errorMsg);
                that.GetList();
              } else {
                that.$message.error(res.errorMsg);
              }
            })
            .catch(() => {
              that.isloading = false;
            });
        },
        onCancel() {}
      });
    }
  }
};
</script>

<style>
.ant-advanced-search-form .ant-form-item {
  display: flex;
}

.ant-advanced-search-form .ant-form-item-control-wrapper {
  flex: 1;
}

#components-form-demo-advanced-search .ant-form {
  max-width: none;
}

#components-form-demo-advanced-search .search-result-list {
  margin-top: 16px;
  border: 1px dashed #e9e9e9;
  border-radius: 6px;
  background-color: #fafafa;
  min-height: 200px;
  text-align: center;
  padding-top: 80px;
}
</style>

